module.exports = __webpack_public_path__ + "img/麦饭石.169bd366.jpg";